// Modules
import { useFormContext } from "react-hook-form"

// Constants
import { ERROR_MESSAGES } from "~constants/errorMessages"

// Components
import Input from "~app/Input"
import Textarea from "~app/Textarea"
import { WizardColumn, WizardRow, WizardStepContainer } from "~styled/wizard"
import MarkdownEditor from "~app/MarkdownEditor"

interface StepProps {
  isVisible: boolean
}

const PerkModalStep2 = ({ isVisible = true }: StepProps) => {
  const { formState: { errors }, register, setValue, getValues, unregister } = useFormContext()

  return (
    <WizardStepContainer className={isVisible ? "visible" : ""}>
      <WizardRow>
        <WizardColumn>
          <Input
            name="code"
            placeholder="e.g. vwe-platinum-passport"
            label="*Perk code"
            register={register("code", { required: true })}
            errorMessage={errors.code && ERROR_MESSAGES.FIELD_REQUIRED}
          />
        </WizardColumn>
      </WizardRow>

      <WizardRow>
        <WizardColumn>
          <Input
            name="name"
            label="*Perk title"
            register={register("name", { required: true })}
            errorMessage={errors.name && ERROR_MESSAGES.FIELD_REQUIRED}
          />
        </WizardColumn>

        <WizardColumn>
          <Input
            name="shortDescription"
            label="*Tag"
            register={register("shortDescription", { required: true })}
            errorMessage={
              errors.shortDescription && ERROR_MESSAGES.FIELD_REQUIRED
            }
          />
        </WizardColumn>
      </WizardRow>

      <WizardRow>
        <WizardColumn>
          <MarkdownEditor
            name="description"
            label="*Description"
            required={false}
            errorMessage={errors.description}
            {...{ register, setValue, getValues, unregister }}
          />
        </WizardColumn>
      </WizardRow>

      <WizardRow>
        <WizardColumn>
          <Textarea
            name="rules"
            label="*Rules description"
            register={register("rules", { required: true })}
            maxLength={200}
            errorMessage={errors.rules && ERROR_MESSAGES.FIELD_REQUIRED}
          />
        </WizardColumn>
      </WizardRow>

      <WizardRow>
        <WizardColumn>
          <Input
            name="successRedemptionTitle"
            label="*Success Redemption Title"
            register={register("successRedemptionTitle", { required: true })}
          />
        </WizardColumn>
      </WizardRow>

      <WizardRow>
        <WizardColumn>
          <MarkdownEditor
            name="redeemInstructions"
            label="Redeem instructions"
            required={false}
            errorMessage={errors.redeemInstructions}
            {...{ register, setValue, getValues, unregister }}
          />
        </WizardColumn>
      </WizardRow>

      <WizardColumn>
        <MarkdownEditor
          name="termsAndConditions"
          label="Terms and Conditions"
          errorMessage={errors.termsAndConditions}
          required={false}
          {...{ register, setValue, getValues, unregister }}
        />
      </WizardColumn>
    </WizardStepContainer>
  )
}

export default PerkModalStep2
